let footerLoading = false;

function loadFooter() {
  const callbacks = Array.from(arguments).filter(function (callback) {
    return typeof callback === "function";
  });

  if ($("footer#footer").length || footerLoading) {
    callbacks.forEach(function (callback) {
      callback();
    });
    return;
  }

  footerLoading = true;
  if (sessionStorage.loadedFooter) {
    $(".overall-wrapper").append('<footer id="footer">' + sessionStorage.loadedFooter + "</footer>");
    footerLoading = false;
    callbacks.forEach(function (callback) {
      callback();
    });
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      url: "/",
      success: function (e) {
        var a = shoptet.common.createDocumentFromString(e),
          t = $(a).find("footer#footer").html();
        if (t) {
          $(".overall-wrapper").append('<footer id="footer">' + t + "</footer>");
          sessionStorage.loadedFooter = t;
        }
        footerLoading = false;
        callbacks.forEach(function (callback) {
          callback();
        });
      },
    });
  }
}
